export default function isPwa() {
  return window.matchMedia("(display-mode: standalone)").matches;
}
